<template>
	<div class="">
		<header-vue></header-vue>
		<div class="container-l2">
		 	<h1 class="h11">动态管理</h1>
			<el-form class="form-news" label-width="80px" :model="news">
			  <el-form-item label="标题">
			    <el-input class="width3" v-model="news.title"></el-input>
			  </el-form-item>
			  <el-form-item label="动态类型">
			    <el-select v-model="news.pid" placeholder="请选择类型">
			      <el-option label="产品介绍" value="1"></el-option>
			      <el-option label="公司动态" value="2"></el-option>
			    </el-select>
			  </el-form-item>
			  <el-form-item label="图片">
			    <el-upload
			        :action='picUrl'
			        ref='upload'
			        list-type="picture-card"
			        accept="image/*"
			        :limit="imgLimit"
			        :file-list="productImgs"
			        :multiple="isMultiple"
			        :on-preview="handlePictureCardPreview"
			        :on-remove="handleRemove"
			        :on-success="handleAvatarSuccess"
			        :before-upload="beforeAvatarUpload"
			        :on-exceed="handleExceed"
			        :on-error="imgUploadError">
			        <i class="el-icon-plus"></i>
			      </el-upload>
			  </el-form-item>
			  
			  <el-form-item label="内容">
			    <el-input type="textarea" v-model="news.content"></el-input>
			  </el-form-item>
			  <el-form-item class="text-center">
			    <el-button type="primary" @click="onSubmit">确认提交</el-button>
			  </el-form-item>
			  
			</el-form>
			<el-dialog :visible.sync="dialogVisible" size="tiny">
			  <img width="100%" :src="dialogImageUrl" alt="">
			</el-dialog>
		</div>
	</div>
</template>

<script>
	export default {
	    data() {
	      return {
	        news: {
	          title: '',
	          content: '',
	          pid: '',
	          picurl:''
	        },
	        dialogImageUrl: '',
	        dialogVisible: false,
	        productImgs: [],
	        isMultiple: true,
	        imgLimit: 1,
	        posturl: this.$store.state.domain+"/Home/ProductAdd/ProductAdd",
	        picUrl: this.$store.state.domain+"/Home/UploadPicture/UploadPicture"

	      };
	    },
	    mounted(){
		    this.$nextTick(function(){
				this.initNews();
		  	})
		  },
	    methods:{
	    	initNews(){
	    		if(this.$route.query.index){
	    			this.news.content = this.$route.query.content;
	    			this.news.picurl = this.$route.query.picurl;
	    			this.news.title = this.$route.query.title;
	    			this.news.pid = this.$route.query.pid;
	    			this.news.id = this.$route.query.id;
	    			this.posturl = this.$store.state.domain+"/Home/ProductRevise/ProductRevise"
	    			this.productImgs= [{
			        	name:'',
			        	url:this.news.picurl
			        }];
	    		}else{
	    			
	    			this.posturl = this.$store.state.domain+"/Home/ProductAdd/ProductAdd"
	    		}
	    	},
			onSubmit(){
				if(this.news.title.length>15){
					this.$message.error("标题长度不能超过15字");
				}else{
					let setNewPassParams={
			  			uid:this.getCookie('uid'),
			  			timestamp:Date.parse( new Date()),
			  			pid:this.news.pid,
			  			id:this.news.id,
			  			title:this.news.title,
			  			content:this.news.content,
			  			picurl:this.news.picurl,
			  		    terminalId:4
			  		};
			  		this.sign(setNewPassParams);
			  		this.$ajax.post(this.posturl,this.$qs.stringify(setNewPassParams),{
			            emulateJSON: true
			        }).then(res=>{
			        	if(res.data.status==1){
//			        		this.news = {
//					          title: '',
//					          content: '',
//					          pid: '',
//					          picurl:''
//					        }
			        		this.$message.success('动态添加成功!');
//			        		this.$refs.upload.clearFiles();
			        		
			        	}else if(res.data.code==10008){
			        		this.delCookie('username');
							this.$router.push('/login/');
							this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo);
			        	}else{
			        		//console.log(res.data.msg);
			        		this.$message.error(res.data.msg);
			        	}
			  		});
				}
				
			},
	    	 handleRemove(file, fileList) {//移除图片
//		        console.log(file, fileList);
		      },
		      handlePictureCardPreview(file) {//预览图片时调用
//		        console.log(file);
		        this.dialogImageUrl = file.url;
		        this.dialogVisible = true;
		      },
		 
		      beforeAvatarUpload(file) {//文件上传之前调用做一些拦截限制
//		        console.log(file);
		        const isJPG = true;
		        // const isJPG = file.type === 'image/jpeg';
		        const isLt2M = file.size / 1024 / 1024 < 2;
		 
		        // if (!isJPG) {
		        //   this.$message.error('上传头像图片只能是 JPG 格式!');
		        // }
		        if (!isLt2M) {
		          this.$message.error('上传图片大小不能超过 2MB!');
		        }
		        return isJPG && isLt2M;
		      },
		      handleAvatarSuccess(res, file) {//图片上传成功
		        //图片地址赋值
		        this.news.picurl = res.data.picurl;
//		        console.log(res)
//		        console.log(file);
		        this.imageUrl = URL.createObjectURL(file.raw);
		      },
		      handleExceed(files, fileList) {//图片上传超过数量限制
		        this.$message.error('只能上传一张图片!');
//		        console.log(file, fileList);
		      },
		      imgUploadError(err, file, fileList){//图片上传失败调用
		        console.log(err)
		        this.$message.error('上传图片失败!');
		      }

	    }
	  }
</script>

<style>
	.el-textarea__inner{
		height: 150px;
	}
</style>


// WEBPACK FOOTER //
// src/components/news.vue